import { detect } from 'tinyld/light'

export function detectLang(sentence: string): string {
  return detect(sentence)
}
